import classNames from 'classnames'
import React from 'react'

import {
  NO_VALUE_AVAILABLE_TEXT,
  NoValueAvailableProps,
} from 'shared-libs/components/ui2/fields/field-ui/no-value-available/no-value-available-props'

import './_no-value-available.scss'

export { NO_VALUE_AVAILABLE_TEXT }

type WebNoValueAvailableProps = Omit<NoValueAvailableProps, 'style'> & {
  style?: React.CSSProperties
  className?: string
}

/**
 * Empty read-only placeholder. Grey italic by default; pass `text` for
 * domain-specific wording ('No files available', 'QR code not available').
 */
export function UI2NoValueAvailable(props: WebNoValueAvailableProps) {
  const { style, className, text } = props
  return (
    <span className={classNames('ui2-noValueAvailable', className)} style={style}>
      {text || NO_VALUE_AVAILABLE_TEXT}
    </span>
  )
}
